import { Stack, Flex, Spinner } from "@chakra-ui/react";
import React from "react"
import backgroundImg from '../../../../../assets/report/background.png'
import { BillingTableTitle } from "./BillingTableTitle";
import { BillingReportBody } from "./BillingReportBody";

type Props = {
    startDate: Date;
    endDate: Date;
    locations: any,
    isDownloading: boolean
    displayData: any
}

export const BillingReportModal = ({ locations, displayData, startDate, endDate, isDownloading }: Props) => {
    return (
        <Stack
            width="100%"
            height="100%"
            alignItems="center"
            id='pdf-container'
            backgroundImage={`url('${backgroundImg}')`}
            backgroundRepeat="no-repeat"
            backgroundSize="cover"
            backgroundPosition="left"
        >
            <Flex direction="column" justifyContent="center" alignItems="center" width="100%" height="100%">
                {isDownloading ? (
                    <Spinner
                        thickness='4px'
                        speed='0.65s'
                        emptyColor='gray.200'
                        color='blue.500'
                        size='xl'
                    />
                ) :
                    <>
                        <BillingTableTitle locations={locations} data={displayData} endDate={endDate} startDate={startDate} />
                        <BillingReportBody locations={locations} data={displayData} />
                    </>
                }
            </Flex>
        </Stack>
    )
}